import { useEditStore } from '../../hooks';
import { ComponentRegistrationModalView } from '../../components/ComponentRegistrationModalView';

export const ComponentEditModal = () => {
  const editStore = useEditStore();

  return <ComponentRegistrationModalView {...editStore} />;
};
